import { render, staticRenderFns } from "./Report-services.vue?vue&type=template&id=2536d4b2&"
import script from "./Report-services.vue?vue&type=script&lang=js&"
export * from "./Report-services.vue?vue&type=script&lang=js&"
import style0 from "./Report-services.vue?vue&type=style&index=0&id=2536d4b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports